import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        about: "La Société",
        services: "Prestations",
        projects: "Projets",
        availabilities: "Disponibilités",
        gallery: "Galerie",
        contact: "Contact",
      },
      cta: {
        discoverProjects: "Découvrir nos projets",
        contactUs: "Nous contacter",
        learnMore: "En savoir plus",
        requestInfo: "Demander des informations",
        bookVisit: "Demander une visite",
        viewAll: "Voir tout",
        viewProject: "Voir le projet",
        send: "Envoyer",
        cancel: "Annuler",
        sending: "Envoi…",
      },
      common: {
        loading: "Chargement…",
        of: "de",
        languageLabel: "Langue",
      },
      hero: {
        location: "Oran — Algérie",
        title1: "Bâtir des lieux",
        title2: "où il fait bon vivre.",
      },
      home: {
        aboutOverline: "À propos",
        aboutTitle: "Un promoteur immobilier d'exception à Oran.",
        servicesOverline: "Nos prestations",
        servicesTitle: "Un savoir-faire intégré, de A à Z.",
        featuredOverline: "Projets à la une",
        featuredTitle: "Nos signatures architecturales.",
        ongoingOverline: "Projets en cours",
        ongoingTitle: "Les chantiers en mouvement.",
        availOverline: "Disponibilités",
        availTitle: "Logements disponibles à la réservation.",
        viewAllAvail: "Voir toutes les disponibilités",
        whyOverline: "Pourquoi nous choisir",
        whyTitle: "Une exigence absolue à chaque étape.",
        testimOverline: "Ils nous ont fait confiance",
        testimTitle: "La confiance, notre plus belle récompense.",
        contactOverline: "Contact direct",
        contactTitle: "Parlons de votre projet immobilier.",
        contactDesc: "Nos chargés de clientèle répondent à toutes vos questions et organisent une visite des projets sur simple demande.",
        callbackCta: "Demander un rappel",
      },
      project: {
        statusRealised: "Réalisé",
        statusOngoing: "En cours",
        statusFuture: "À venir",
        programOverline: "Le programme",
        highlightsOverline: "Points forts",
        amenitiesOverline: "Équipements & commodités",
        progressLabel: "État d'avancement",
        completed: "complété",
        launch: "Lancement",
        delivery: "Livraison prévue",
        units: "Logements",
        typologies: "Typologies",
        surfaces: "Surfaces",
        galleryOverline: "Galerie",
        galleryTitle: "Plongez dans le projet.",
        locationOverline: "Localisation",
        linkedAvail: "Disponibilités liées",
        linkedAvailTitle: "Logements à réserver.",
        similar: "Projets similaires.",
        similarOverline: "À découvrir aussi",
        shareOverline: "Partager",
        downloadBrochure: "Télécharger la brochure",
      },
      avail: {
        statusAvailable: "Disponible",
        statusReserved: "Réservé",
        statusSold: "Vendu",
        searchPlaceholder: "Rechercher une référence…",
        allProjects: "Tous les projets",
        allTypes: "Tous les types",
        allStatus: "Tous",
        noResult: "Aucune disponibilité ne correspond à votre recherche.",
      },
      contact: {
        coordOverline: "Coordonnées",
        listenTitle: "À votre écoute, du dimanche au jeudi.",
        formOverline: "Formulaire",
        formTitle: "Demander à être recontacté",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        subject: "Sujet",
        message: "Message",
        projectConcerned: "Projet concerné (optionnel)",
        successTitle: "Message envoyé.",
        successDesc: "Merci pour votre demande. Un conseiller AMAR SAHRAOUI vous recontactera sous 24h ouvrées.",
        sendOther: "Envoyer un autre message",
      },
      visit: {
        title: "Demander une visite",
        subtitle: "Choisissez votre préférence et nous reviendrons vers vous sous 24h.",
        typeOnSite: "Visite sur place",
        typeVirtual: "Visite virtuelle",
        typeCallback: "Être rappelé",
        date: "Date souhaitée",
        time: "Créneau",
        morning: "Matin",
        afternoon: "Après-midi",
        notes: "Notes (optionnel)",
        submit: "Envoyer la demande",
        successTitle: "Demande envoyée.",
        successDesc: "Merci, un conseiller AMAR SAHRAOUI vous rappellera sous 24h pour confirmer votre visite.",
      },
      footer: {
        nav: "Navigation",
        contact: "Contact",
        rights: "Tous droits réservés.",
        legal: "Mentions légales",
        privacy: "Politique de confidentialité",
      },
    },
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        about: "About",
        services: "Services",
        projects: "Projects",
        availabilities: "Availability",
        gallery: "Gallery",
        contact: "Contact",
      },
      cta: {
        discoverProjects: "Discover our projects",
        contactUs: "Contact us",
        learnMore: "Learn more",
        requestInfo: "Request information",
        bookVisit: "Book a visit",
        viewAll: "View all",
        viewProject: "View project",
        send: "Send",
        cancel: "Cancel",
        sending: "Sending…",
      },
      common: {
        loading: "Loading…",
        of: "of",
        languageLabel: "Language",
      },
      hero: {
        location: "Oran — Algeria",
        title1: "Building places",
        title2: "where life feels right.",
      },
      home: {
        aboutOverline: "About",
        aboutTitle: "An exceptional real-estate developer in Oran.",
        servicesOverline: "Our services",
        servicesTitle: "Integrated expertise, from A to Z.",
        featuredOverline: "Featured projects",
        featuredTitle: "Our architectural signatures.",
        ongoingOverline: "Ongoing projects",
        ongoingTitle: "Construction sites in motion.",
        availOverline: "Availability",
        availTitle: "Units available for reservation.",
        viewAllAvail: "View all availabilities",
        whyOverline: "Why choose us",
        whyTitle: "Uncompromising excellence at every step.",
        testimOverline: "They trusted us",
        testimTitle: "Trust, our finest reward.",
        contactOverline: "Direct contact",
        contactTitle: "Let's talk about your project.",
        contactDesc: "Our advisors answer your questions and arrange a project visit on simple request.",
        callbackCta: "Request a callback",
      },
      project: {
        statusRealised: "Delivered",
        statusOngoing: "Ongoing",
        statusFuture: "Upcoming",
        programOverline: "The program",
        highlightsOverline: "Highlights",
        amenitiesOverline: "Amenities",
        progressLabel: "Progress",
        completed: "completed",
        launch: "Launch",
        delivery: "Delivery",
        units: "Units",
        typologies: "Layouts",
        surfaces: "Areas",
        galleryOverline: "Gallery",
        galleryTitle: "Step inside the project.",
        locationOverline: "Location",
        linkedAvail: "Linked availability",
        linkedAvailTitle: "Units to reserve.",
        similar: "Similar projects.",
        similarOverline: "You may also like",
        shareOverline: "Share",
        downloadBrochure: "Download brochure",
      },
      avail: {
        statusAvailable: "Available",
        statusReserved: "Reserved",
        statusSold: "Sold",
        searchPlaceholder: "Search a reference…",
        allProjects: "All projects",
        allTypes: "All types",
        allStatus: "All",
        noResult: "No availability matches your search.",
      },
      contact: {
        coordOverline: "Contact details",
        listenTitle: "Available Sunday to Thursday.",
        formOverline: "Form",
        formTitle: "Request a callback",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        message: "Message",
        projectConcerned: "Project (optional)",
        successTitle: "Message sent.",
        successDesc: "Thank you for reaching out. An AMAR SAHRAOUI advisor will contact you within 24 working hours.",
        sendOther: "Send another message",
      },
      visit: {
        title: "Book a visit",
        subtitle: "Choose your preference and we will get back to you within 24h.",
        typeOnSite: "On-site visit",
        typeVirtual: "Virtual tour",
        typeCallback: "Call me back",
        date: "Preferred date",
        time: "Time slot",
        morning: "Morning",
        afternoon: "Afternoon",
        notes: "Notes (optional)",
        submit: "Send request",
        successTitle: "Request sent.",
        successDesc: "Thank you, an AMAR SAHRAOUI advisor will call you within 24h to confirm.",
      },
      footer: {
        nav: "Navigation",
        contact: "Contact",
        rights: "All rights reserved.",
        legal: "Legal notice",
        privacy: "Privacy policy",
      },
    },
  },
  ar: {
    translation: {
      nav: {
        home: "الرئيسية",
        about: "الشركة",
        services: "الخدمات",
        projects: "المشاريع",
        availabilities: "المتاح",
        gallery: "المعرض",
        contact: "اتصل بنا",
      },
      cta: {
        discoverProjects: "اكتشف مشاريعنا",
        contactUs: "اتصل بنا",
        learnMore: "اعرف المزيد",
        requestInfo: "طلب معلومات",
        bookVisit: "حجز زيارة",
        viewAll: "عرض الكل",
        viewProject: "عرض المشروع",
        send: "إرسال",
        cancel: "إلغاء",
        sending: "جاري الإرسال…",
      },
      common: {
        loading: "جاري التحميل…",
        of: "من",
        languageLabel: "اللغة",
      },
      hero: {
        location: "وهران — الجزائر",
        title1: "نبني أماكن",
        title2: "تليق بالحياة.",
      },
      home: {
        aboutOverline: "من نحن",
        aboutTitle: "مطوّر عقاري استثنائي في وهران.",
        servicesOverline: "خدماتنا",
        servicesTitle: "خبرة متكاملة من الألف إلى الياء.",
        featuredOverline: "مشاريع مميزة",
        featuredTitle: "بصماتنا المعمارية.",
        ongoingOverline: "مشاريع قيد التنفيذ",
        ongoingTitle: "ورشات في حركة دائمة.",
        availOverline: "المتاح",
        availTitle: "وحدات متاحة للحجز.",
        viewAllAvail: "عرض جميع الوحدات المتاحة",
        whyOverline: "لماذا تختارنا",
        whyTitle: "التميّز في كل مرحلة.",
        testimOverline: "وثقوا بنا",
        testimTitle: "الثقة، أجمل مكافأة.",
        contactOverline: "تواصل مباشر",
        contactTitle: "لنتحدث عن مشروعك العقاري.",
        contactDesc: "مستشارونا يجيبون عن جميع أسئلتكم وينظمون زيارات للمشاريع عند الطلب.",
        callbackCta: "اطلب أن نعاود الاتصال بك",
      },
      project: {
        statusRealised: "تم الإنجاز",
        statusOngoing: "قيد التنفيذ",
        statusFuture: "قادم",
        programOverline: "البرنامج",
        highlightsOverline: "أبرز المميزات",
        amenitiesOverline: "التجهيزات والمرافق",
        progressLabel: "نسبة التقدم",
        completed: "مكتمل",
        launch: "الإطلاق",
        delivery: "التسليم",
        units: "الوحدات",
        typologies: "الأنماط",
        surfaces: "المساحات",
        galleryOverline: "المعرض",
        galleryTitle: "تجوّل داخل المشروع.",
        locationOverline: "الموقع",
        linkedAvail: "الوحدات المتاحة",
        linkedAvailTitle: "وحدات للحجز.",
        similar: "مشاريع مشابهة.",
        similarOverline: "اقتراحات أخرى",
        shareOverline: "مشاركة",
        downloadBrochure: "تحميل الكتيب",
      },
      avail: {
        statusAvailable: "متاح",
        statusReserved: "محجوز",
        statusSold: "مباع",
        searchPlaceholder: "ابحث عن مرجع…",
        allProjects: "جميع المشاريع",
        allTypes: "جميع الأنواع",
        allStatus: "الكل",
        noResult: "لا توجد وحدات تطابق بحثك.",
      },
      contact: {
        coordOverline: "بيانات الاتصال",
        listenTitle: "في خدمتكم من الأحد إلى الخميس.",
        formOverline: "نموذج",
        formTitle: "اطلب أن نعاود الاتصال بك",
        firstName: "الاسم",
        lastName: "اللقب",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        subject: "الموضوع",
        message: "الرسالة",
        projectConcerned: "المشروع المعني (اختياري)",
        successTitle: "تم إرسال الرسالة.",
        successDesc: "شكراً لتواصلكم. سيتواصل معك مستشار من AMAR SAHRAOUI خلال 24 ساعة عمل.",
        sendOther: "إرسال رسالة أخرى",
      },
      visit: {
        title: "حجز زيارة",
        subtitle: "اختر تفضيلك وسنعاود الاتصال بك خلال 24 ساعة.",
        typeOnSite: "زيارة ميدانية",
        typeVirtual: "زيارة افتراضية",
        typeCallback: "اتصل بي",
        date: "التاريخ المفضل",
        time: "الوقت",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        notes: "ملاحظات (اختياري)",
        submit: "إرسال الطلب",
        successTitle: "تم إرسال الطلب.",
        successDesc: "شكراً، سيتصل بك مستشار من AMAR SAHRAOUI خلال 24 ساعة لتأكيد الزيارة.",
      },
      footer: {
        nav: "التنقل",
        contact: "اتصل",
        rights: "جميع الحقوق محفوظة.",
        legal: "إشعار قانوني",
        privacy: "سياسة الخصوصية",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: ["fr", "ar", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "amar_lang",
    },
  });

// Sync html lang & dir on language change
const applyDir = (lng) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
};
applyDir(i18n.language || "fr");
i18n.on("languageChanged", applyDir);

export default i18n;
